var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 405 512.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF750A",
    d: "M0 512.54V237.38c66.04-26.05 81.61-94.41 56.12-190.3L124.04 0c46.03 32.03 110.89 32.03 156.92 0l67.92 47.08c-25.49 95.89-9.92 164.25 56.12 190.3v275.16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADCDE",
    d: "M405 349.08v-65.41H209.24v65.41zm0 115.89v-65.4H209.24v65.4zM0 349.08v-65.41h195.76v65.41zm0 115.89v-65.4h195.76v65.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M211.79 171.36v341.18h-18.06V170.91c1.32 1.14 2.67 2.25 4.03 3.35 3.51 2.82 8.52 2.5 11.63-.59l2.4-2.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M116.08 5.52 124.04 0c3.21 2.23 6.52 4.31 9.9 6.23 5.64 32.54 13.98 62.04 25.78 87.61 11.32 24.51 24.68 45.38 43.1 61.78 19.34-19.47 36.39-41.09 47.95-65.41 11.91-25.03 19.29-52.99 21.16-84.47 3.08-1.79 6.09-3.7 9.03-5.74l8.48 5.88c-1.93 34.2-9.9 64.59-22.84 91.8-13.62 28.63-33.86 53.71-57.21 75.99-3.11 3.09-8.12 3.41-11.63.59-23.47-18.86-40.34-43.62-53.94-73.09-12.9-27.93-21.84-60.16-27.74-95.65z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.05156c13bf20223dc64c1838ebe9135c.svg";
export { ForwardRef as ReactComponent };